module.exports = __webpack_public_path__ + "static/media/201IT151.6545f963.jpg";